import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import type React from 'react';
import Notification, { type NotificationProps } from './Notification';

interface NotificationDrawerProps {
  open: boolean;
  onClose: () => void;
  notifications: Omit<NotificationProps, 'onDelete'>[];
  onDelete: (id: string) => void;
  onDeleteAll: () => void;
}

const NotificationDrawer: React.FC<NotificationDrawerProps> = ({
  open,
  onClose,
  notifications,
  onDelete,
  onDeleteAll,
}) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} data-testid="notification-drawer">
      <Box sx={{ width: 400, p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">Notifications</Typography>
          <Box>
            {notifications.length > 0 && (
              <Button onClick={onDeleteAll} size="small">
                Clear All
              </Button>
            )}
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <Notification key={notification.id} {...notification} onDelete={onDelete} />
          ))
        ) : (
          <Typography>No new notifications</Typography>
        )}
      </Box>
    </Drawer>
  );
};

export default NotificationDrawer;
